// extracted by mini-css-extract-plugin
export default {"root":"AcceptableUsePolicy_root__j5IK0","lastUpdated":"AcceptableUsePolicy_lastUpdated__fSJ5J","listTitle":"AcceptableUsePolicy_listTitle__6836L"};